import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOnboardingLuminiares = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.5 3C5.5 7.6875 3 8 3 10.8125C3 13.9375 5.08333 15.5 8 15.5C10.9167 15.5 13 13.9375 13 10.8125C13 8 10.5 7.6875 10.5 3",
		stroke: "#232323",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.5 1H10.5",
		stroke: "#232323",
		strokeWidth: 1.4,
		strokeLinecap: "round"
	})]
});
export default SvgOnboardingLuminiares;
